<main id="main">
    
    <div id="main-container">
        
        @if(uiService.navigationBar()){
            <app-navigation-bar/>
        }
        
        <div id="main-wrapper">

            <div class="d-flex flex-row align-items-center">
                @if(uiService.navigationBar() && !uiService.isMobile()){
                    <app-navigation-bar-toggle/>
                }
                
                @if(uiService.companyBar()){
                    <app-company-bar class="flex-grow-1"/>
                }
            </div>

            <div id="main-body" [class]="{
                'main-body-m-top': !uiService.companyBar(),
                'main-body-m-left': !uiService.navigationBar() || this.uiService.isMobile(),
                'main-body-m-right': !false,
                'main-body-m-bottom': !false,
            }">
                    
                <div id="main-drawer-container" class="position-absolute overflow-hidden top-0 bottom-0 left-0 right-0">
                    <app-navigation-drawer/>
                </div>
            
                <div id="main-content">
                    
                    <div class="position-absolute overflow-auto top-0 bottom-0 left-0 right-0 bg--primary" [class.d-none]="uiService.loadingScreen()">
                        <router-outlet/>
                    </div>
                    
                    @if(uiService.loadingScreen()){
                        <div class="position-absolute overflow-auto top-0 bottom-0 left-0 right-0 bg--primary">
                            <app-loading-screen/>
                        </div>
                    }
                    
                </div>

                @if(uiService.footerToolbar()){
                    <app-footer-toolbar/>
                }

            </div>
            
        </div>
        
    </div>

    <div id="main-modal-container"></div>
    
    <div class="position-relative">
        @if(uiService.trademark()){
            <app-trademark/>
        }
        @if(uiService.statusBar()){
            <app-status-bar/>
        }
    </div>
    
</main>

<app-login-modal/>
<app-login-sessions-modal/>
<app-change-password-modal/>